import validator from 'validator';

const isValidUuid = (value: string): boolean => {
  return validator.isUUID(value, 4);
};

export default isValidUuid;
